export const AddressNoteMaxLength = 36;
export const AddressNotePlaceholder = 'до 36 символів';
export const BuildingMaxLength = 10;
export const CityMinLength = 2;
export const AddressPartPattern = /^[a-z0-9à-öø-ÿā-žḀ-ỿș-țа-щьюяґєії.\/'"ʹʼ’&()\- ,№:!+#_|„“@–—\s]+$/iu;

export const CityPatternBase = 'a-z0-9à-öø-ÿā-žḀ-ỿș-țа-щьюяґєії.\\/\'"ʼ’&()*№;:!+#_|„“@–—\\s';
// 1. Регулярка для всіх країн КРІМ Молдови
export const CityPattern = new RegExp(`^[${CityPatternBase}]+$`, 'iu');
